import { defineComponent as _defineComponent } from 'vue';
import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode } from "vue";
const _hoisted_1 = { class: "national-id-field" };
const _hoisted_2 = ["for"];
const _hoisted_3 = {
    key: 0,
    class: "text-muted small"
};
const _hoisted_4 = ["id", "value", "inputmode", "autocapitalize", "placeholder", "disabled", "required"];
const _hoisted_5 = {
    key: 1,
    class: "form-text mb-0"
};
import { computed } from "vue";
import { formatNationalIdDisplay, formatNationalIdInput, getNationalIdSpec, nationalIdInputMode, } from "@/utils/nationalId";
export default /*@__PURE__*/ _defineComponent({
    __name: 'NationalIdInput',
    props: {
        modelValue: {},
        country: { default: "CL" },
        hint: { default: "" },
        label: { type: [String, Boolean], default: undefined },
        optional: { type: Boolean, default: false },
        optionalLabel: { default: "(opcional)" },
        disabled: { type: Boolean, default: false },
        required: { type: Boolean, default: false },
        inputClass: { default: "" },
        inputId: { default: "national-id-input" }
    },
    emits: ["update:modelValue"],
    setup(__props, { emit: __emit }) {
        const props = __props;
        const emit = __emit;
        const spec = computed(() => getNationalIdSpec(props.country));
        const inputMode = computed(() => nationalIdInputMode(props.country));
        const usesLetters = computed(() => spec.value.country_code === "CL" || spec.value.country_code === "IT");
        const resolvedLabel = computed(() => props.label === false ? "" : props.label || spec.value.label);
        const hintText = computed(() => props.hint === "" ? spec.value.hint : props.hint);
        const displayValue = computed(() => {
            if (!props.modelValue)
                return "";
            return (formatNationalIdDisplay(props.country, props.modelValue) ||
                props.modelValue);
        });
        const onInput = (event) => {
            const target = event.target;
            emit("update:modelValue", formatNationalIdInput(props.country, target.value));
        };
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("div", _hoisted_1, [
                (_ctx.label !== false)
                    ? (_openBlock(), _createElementBlock("label", {
                        key: 0,
                        class: "form-label",
                        for: _ctx.inputId
                    }, [
                        _createTextVNode(_toDisplayString(resolvedLabel.value) + " ", 1),
                        (_ctx.optional)
                            ? (_openBlock(), _createElementBlock("span", _hoisted_3, _toDisplayString(_ctx.optionalLabel), 1))
                            : _createCommentVNode("", true)
                    ], 8, _hoisted_2))
                    : _createCommentVNode("", true),
                _createElementVNode("input", {
                    id: _ctx.inputId,
                    value: displayValue.value,
                    type: "text",
                    class: _normalizeClass(["form-control", _ctx.inputClass]),
                    inputmode: inputMode.value,
                    autocapitalize: usesLetters.value ? 'characters' : 'off',
                    autocomplete: "off",
                    spellcheck: "false",
                    placeholder: spec.value.placeholder,
                    disabled: _ctx.disabled,
                    required: _ctx.required,
                    onInput: onInput
                }, null, 42, _hoisted_4),
                (hintText.value)
                    ? (_openBlock(), _createElementBlock("p", _hoisted_5, _toDisplayString(hintText.value), 1))
                    : _createCommentVNode("", true)
            ]));
        };
    }
});
